import React from 'react';
import SingleImageCarousel from './SingleImageCarousel';
import StackedImagesCarousel from './StackedImagesCarousel';

const Carousel = props => {
  if (props.isStacked) {
    return <StackedImagesCarousel {...props} />;
  }
  return <SingleImageCarousel {...props} />;
};

export default Carousel;
